import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { experiencesApi as n } from "@maat/api-main";
//#region src/experiences/useExperienceDetailQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getExperience(r)
});
//#endregion
export { r as useExperienceDetailQuery };
